// istanbul ignore file

/**
 * Standalone Cookbook is rendered inside the HTML rendered by the Rails backend
 * under the https://cloudinary.com/internal_template URL.
 *
 * The React app is hydrated within a specific container on that side.
 * The constant below contains id of that container.
 */
const HYDRATE_CONTAINER_ID = 'main';

export const getHydrateTarget = () => document.getElementById(HYDRATE_CONTAINER_ID);
